<style lang="stylus">
    .font-set-wrapper
        width 100%
        padding: 0 15px 0 16px;
        margin-top 8px
        .fontset-box
            margin-bottom 16px;
            > div
                padding-top 4px
            .box-title
                border-top none
                height 40px
                line-height 40px
                font-size: 14px;
                font-weight: 700;
                text-align: left;
                color var(--text-color-primary)
        .text-set-box
            .text-box-line
                display flex;
                justify-content space-between
                &:first-child
                    margin-bottom 12px
                &.disabled
                    .font-selecter
                        color: var(--text-color-ivu-input-disabled);
                        background-color: var(--bg-color-ivu-input-number-input-disabled) !important;
                        cursor not-allowed
                        .font-name
                            cursor not-allowed
                        .down-arrow
                            opacity 0.4
                            cursor not-allowed
                        .inputBox
                            pointer-events none;
                        .inputBox-arrow
                            cursor not-allowed
                    .font-btn
                        cursor not-allowed!important
                        background-color transparent !important
                        &:hover
                            background-color transparent !important
                        svg
                            opacity 0.4
                .font-selecter
                    position relative
                    height 24px
                    box-sizing border-box
                    border: 1px solid $box-bordercolor;
                    border-radius: 4px;
                    color: var(--text-color-primary);
                    &.font-family-set
                        width 136px
                        margin-right 12px
                    &.font-size-set
                        margin-right 0
                        width 80px
                    &:hover{
                        background-color: $main-hovercolor;
                        border-color $main-hovercolor
                    }
                    .font-name
                        margin: 0
                        text-indent 8px
                        width 100%
                        padding-right 12px
                        height 24px
                        display block
                        white-space nowrap
                        overflow hidden
                        text-overflow ellipsis
                        line-height 22px
                        cursor pointer
                        background-color: transparent;
                        font-size: 12px;
                        font-weight: 400;
                        text-align: left;
                    .inputBox
                        outline none
                        border none
                        height 22px
                        width 46px
                        cursor auto
                        -moz-appearance textfield
                    input::-webkit-outer-spin-button, input::-webkit-inner-spin-button
                        -webkit-appearance none
                        appearance none
                        margin 0
                    input:disabled
                        background unset
                        border unset
                    .inputBox-arrow
                        position absolute
                        right 0
                        top 0
                        height 100%
                        width 16px
                        user-select none
                        cursor pointer

                    .font-list
                        margin-top: 2px
                        padding: 6px
                        background-color var(--bg-color-tertiary)
                        box-shadow $box-shadow
                        height 400px
                        overflow auto
                        border-radius: $box-radius;
                        position relative
                        z-index 2
                        li
                            list-style none
                            padding 5px 4px
                            margin-bottom 2px
                            user-select none
                            cursor pointer
                            border-radius: $box-radius;
                            &:hover
                                background-color $common-hover-color
                            &.active
                                background-color var(--bg-color-font-list-active)
                    .down-arrow
                        position absolute
                        top: 50%;
                        right: 5px
                        transform: translate(0, -50%);
                        width 8px
                        height 4.24px
                        cursor pointer
                        color var(--svg-color-primary)

                .font-btn
                    float left
                    position relative
                    width 28px
                    height 28px
                    padding 2px;
                    margin-right 3px
                    user-select none
                    position: relative;
                    border-radius $common-border-radius
                    &:not(.navigation-ban-btn)
                        cursor pointer
                    .item-arrow
                        position absolute
                        top: 15px;
                        right: 0px;
                        width 8px
                        height 4.25px
                        color var(--svg-color-primary)

                    .item-icon-center
                        pointer-events none;
                        position: absolute;
                        top: 50%;
                        left 50%;
                        transform: translate(-50%,-50%);
                        width 24px
                        height 24px
                        color: var(--svg-color-primary);
                    .item-icon-expand
                        left 45%;
                    .item-icon
                        width 24px
                        height 24px
                        color var(--svg-color-primary)
                    .item-color
                        pointer-events none;
                        position absolute
                        bottom 7px
                        margin-left 8px
                        width 16px
                        height 3px
                        border-radius 1.5px

                    .font-btn-arrow
                        position absolute
                        right 0
                        bottom 0

                    &:not(.font-btn-active):not(.activeFunc):not(.navigation-ban-btn):hover
                        background-color $main-hovercolor

                    .liststylemodalwrapper
                        ul
                            padding 16px
                            width 168px
                            height 168px
                            background $ft-bgcolor
                            border-radius 6px
                            box-shadow var(--box-shadow-color-expand-drop)
                            list-style none
                            display grid
                            grid-template-columns repeat(3, 1fr)
                            grid-gap 8px;
                            position fixed
                            z-index 1
                            right 10px
                            li
                                width 40px
                                height 40px
                                position relative

                                &:hover, &.active
                                    background-color transparent
                                &:hover
                                    .border
                                        border-color var(--themeColor)
                                &.active
                                    .border
                                        border: 2px solid var(--themeColor)
                                &:nth-child(3n)
                                    margin-right unset
                                .border
                                    width: 40px;
                                    height 40px;
                                    position absolute
                                    top 0;
                                    left 0;
                                    border-radius 6px;
                                    border: 1px solid var(--border-color-box-8)


                                .item-icon
                                    width 40px
                                    height 40px

                    .aroundbox-list
                        width 167px
                        height 180px
                        padding 8px 10px
                        background-color var(--bg-color-tertiary)
                        border-radius 5px
                        box-shadow $common-box-shadow
                        box-sizing border-box
                        z-index 1
                        position absolute
                        top 36px

                        .aroundbox-li
                            float left
                            list-style none
                            width 33px
                            height 33px
                            box-sizing border-box
                            user-select none
                            cursor pointer
                            margin-right 5px

                            &:nth-child(4n)
                                margin-right 0

                            &:not(.ban-btn):hover
                                background-color $main-hovercolor

                            .item-icon
                                margin 3px
                                width 27px
                                height 27px
                                fill: var(--svg-color-navi-font-roundbox);
                                color: var(--svg-color-gray-42);
                                &.fontaround5, &.fontaround6
                                    stroke:  var(--svg-color-gray-42);
                        .roundbox-clean
                            float left
                            width 100%
                            height 24px
                            line-height 24px
                            margin-top 10px
                            border-top 1px solid var(--border-color-navi-font-roundbox)
                            user-select none
                            cursor pointer
                            &:not(.ban-btn)hover
                                background-color $main-hovercolor
                        .ban-btn
                            opacity .2
                            cursor not-allowed

                    .imgbox-list
                        width 155px
                        padding 8px 10px
                        background-color $navigation-modal-bgcolor
                        border-radius 5px
                        box-shadow $common-box-shadow
                        box-sizing border-box
                        z-index 1
                        position absolute
                        top 36px
                        list-style none
                        cursor: default;
                        .dividing{
                        height: 1px;
                        background-color: $box-bordercolor;
                        margin: 4px 0;
                        }
                        .more-btn{
                        border-radius: $box-radius;
                        padding: 2px 7px;
                        cursor: pointer;
                        &:hover{
                            background-color $ft-hover
                        }
                        }
                        .imgbox-li
                            display: inline-block;
                            list-style none
                            width 30px
                            height 30px
                            box-sizing border-box
                            user-select none
                            cursor pointer
                            margin-right 5px
                            position: relative;
                            border-radius: $box-radius;

                            &:nth-child(4n)
                                margin-right 0

                            &:not(.active):hover
                                background-color $main-hovercolor
                            &.active
                                background-color $main-selectcolor
                            .item-icon
                                width 30px
                                height 30px
                                position: absolute;
                                top: 50%;
                                left: 50%;
                                transform: translate(-50%, -50%);
                                color: var(--svg-color-gray-42)
                .activeFunc
                    background-color var(--themeActived)
                .font-btn-active
                    background-color $main-selectcolor
            .text-box-line.text-box-line_fontstyle
                display grid
                grid-template-columns repeat(5, 28px)
                grid-row-gap 12px
        .align-box
            &.disabled
                .align-item
                    cursor not-allowed !important
                    background-color transparent !important
                    &:hover
                        background-color transparent !important
                    svg
                        opacity 0.4
            .align-wrapper
                display flex;
                gap 12px
                .left
                    display flex;
                    gap 3px
                    height 32px
                    padding 2px;
                    border-radius 6px
                    border 1px solid var(--border-color-box-8)
                .align-item
                    padding 1px 4px;
                    height 26px
                    width  32px
                    border-radius 4px
                    cursor pointer
                    &:not(.active):hover
                        background-color $main-hovercolor
                    &.active
                        background-color var(--bg-color-fontalgin-active-item)
                    .item-icon
                        width 24px
                        height 24px
                        color: var(--svg-color-primary)
        .spacing-box, .indent-box,
            flex-direction column
            .inputbox-line
                display flex
                justify-content space-between
                margin-bottom 16px
</style>

<template>
    <div class="font-set-wrapper">
        <div class="fontset-box text-set-box">
            <p class="box-title">{{ $t("textSet") }}</p>
            <div>
                <div class="text-box-line" :class="{ disabled: !isSelect }">
                    <div id="rightfamilyName" class="font-selecter font-family-set">
                        <p class="font-name" @click="clickFamilyName()">{{ activedFamily.replace(/\"/g, "") }}</p>
                        <ul class="font-list" ref="fontList" v-show="showFamilyList">
                            <li
                                v-for="(item, index) in family"
                                :key="index"
                                :style="{ fontFamily: item }"
                                :class="{ active: item == activedFamily }"
                                @mouseenter="startFamilyPreview(item)"
                                @mouseleave="endPreview"
                                @click="clickFamilyList(index)"
                            >
                                {{ item }}
                            </li>
                        </ul>
                        <iconSymbol class="down-arrow" :name="'downArrow'" @click.native="clickFamilyName()"></iconSymbol>
                    </div>
                    <div id="rightSizeName" class="font-selecter font-size-set">
                        <div>
                            <input
                                type="number"
                                class="font-name inputBox"
                                :class="{ disabled: !isSelect }"
                                :style="{ width: '80px' }"
                                v-model="activedSize"
                                @focus="setOldSize($event)"
                                @blur="checkFontSize()"
                                @keyup.enter="iviewInputBlur($event)"
                            />
                            <ul class="font-list" ref="sizeList" v-show="showSizeList">
                                <li
                                    v-for="(item, index) in size"
                                    :key="index"
                                    :class="{ active: item == activedSize }"
                                    @mouseenter="startSizePreview(item - 0)"
                                    @mouseleave="endPreview"
                                    @click="clickSizeList(index)"
                                >
                                    {{ item }}
                                </li>
                            </ul>
                            <div class="inputBox-arrow" @click="clickSizeName()">
                                <iconSymbol class="down-arrow" :name="'downArrow'"></iconSymbol>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-box-line text-box-line_fontstyle" :class="{ disabled: !isSelect }">
                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': bold, activeFunc: activeFunc == 'tabsBold' }"
                        :content="$t('tipsList.bold')"
                        v-tippy="{ placement: 'bottom' }"
                        @click.stop="clickBtn('bold')"
                    >
                        <iconSymbol class="item-icon-center" :name="'bold-large'"></iconSymbol>
                    </div>
                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': italic, activeFunc: activeFunc == 'tabsItaly' }"
                        :content="$t('tipsList.italy')"
                        v-tippy="{ placement: 'bottom' }"
                        @click.stop="clickBtn('italy')"
                    >
                        <iconSymbol class="item-icon-center" :name="'italy-large'"></iconSymbol>
                    </div>
                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': underline, activeFunc: activeFunc == 'tabsUnderline' }"
                        :content="$t('tipsList.underline')"
                        v-tippy="{ placement: 'bottom' }"
                        @click.stop="clickBtn('underline')"
                    >
                        <iconSymbol class="item-icon-center" :name="'underline-large'"></iconSymbol>
                    </div>
                    <div
                        class="font-btn"
                        :class="{ active: strike, activeFunc: activeFunc == 'tabsDeleteLine' }"
                        :content="$t('tipsList.deleteLine')"
                        v-tippy="{ placement: 'bottom' }"
                        @click="clickBtn('strikethrough')"
                    >
                        <iconSymbol class="item-icon" name="new-delline"></iconSymbol>
                    </div>
                    <div class="font-btn" :content="$t('tipsList.fontpath')" v-tippy="{ placement: 'bottom' }">
                        <FontSetPath />
                    </div>
                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': superscript, activeFunc: activeFunc == 'tabsSuperscript' }"
                        :content="$t('tipsList.superscript')"
                        v-tippy="{ placement: 'bottom' }"
                        @click="clickBtn('superscript')"
                    >
                        <iconSymbol class="item-icon" name="superscript-large"></iconSymbol>
                    </div>
                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': subscript, activeFunc: activeFunc == 'tabsSubscript' }"
                        :content="$t('tipsList.subscript')"
                        v-tippy="{ placement: 'bottom' }"
                        @click="clickBtn('subscript')"
                    >
                        <iconSymbol class="item-icon" name="subscript-large"></iconSymbol>
                    </div>
                    <div class="font-btn" :class="{ 'ban-btn': isTextPath, activeFunc: activeFunc == 'tabsFontListStyle' }">
                        <div
                            id="liststylemodal"
                            class="liststylebox"
                            @click="showListStyleModal()"
                            :content="$t('tipsList.listStyle')"
                            v-tippy="{ placement: 'bottom' }"
                            v-click-outside="closeListStyle"
                        >
                            <iconSymbol :class="{ active: selectFontEditor == 2 }" class="item-icon" name="new-liststyle"></iconSymbol>
                            <div class="liststylemodalwrapper" v-show="showListStyle">
                                <ul>
                                    <li
                                        :class="{ active: item.id == listStyleActiveID }"
                                        v-for="item in listStyleList"
                                        :key="item.id"
                                        @click.stop="clickListStyle(item.id)"
                                    >
                                        <iconSymbol class="item-icon" :name="`${item.name}${isDarkTheme() ? '-dark' : ''}`"></iconSymbol>
                                        <div class="border"></div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div
                        class="font-btn"
                        :class="{ 'ban-btn': isTextPath, activeFunc: activeFunc == 'tabsFontBgColor' }"
                        :content="$t('tipsList.bgColor')"
                        v-tippy="{ placement: 'bottom' }"
                        @click="showFontBackgoundColor($event)"
                    >
                        <iconSymbol
                            :style="`pointer-events: none; fill:${fontBackGroundColor}`"
                            :class="{ active: selectFontEditor == 1 }"
                            class="item-icon"
                            :name="`new-backgroundcolor${isDarkTheme() ? '-dark' : ''}`"
                        ></iconSymbol>
                        <!-- <div class="item-color" :style="{ backgroundColor: fontBackGroundColor }"></div> -->
                    </div>
                    <div
                        class="font-btn"
                        :class="{ 'font-btn-active': fontColorWindow, activeFunc: activeFunc == 'tabsFontColor' }"
                        :content="$t('tipsList.textColor')"
                        v-tippy="{ placement: 'bottom' }"
                        @click.stop="showFontColor($event)"
                    >
                        <iconSymbol
                            class="item-icon-center"
                            :style="`top: 48%; fill:${fontColor}`"
                            :name="`new-fontcolorA${isDarkTheme() ? '-dark' : ''}`"
                        ></iconSymbol>
                        <!-- <div
                            class="item-color"
                            :style="{ backgroundColor: fontColor, border: fontColor === '#ffffff' ? '1px solid rgba(0,0,0,0.08)' : '' }"
                        ></div> -->
                        <!-- <iconSymbol class="item-color" :name="'FontColor'"></iconSymbol> -->
                    </div>
                </div>
            </div>
        </div>
        <div class="fontset-box align-box" :class="{ disabled: !isSelect }">
            <p class="box-title">{{ $t("align") }}</p>
            <div class="align-wrapper">
                <div class="left">
                    <div
                        class="align-item"
                        :class="{ active: item.id == fontAlignHActiveID }"
                        v-for="item in fontAlignHList"
                        :key="item.id"
                        @click.stop="clickAlign('h', item.id)"
                        @mouseenter="startPreviewAlign('h', item.id)"
                        @mouseleave="endPreview"
                        :content="$t(`tipsList.${item.name}`)"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol :name="item.name" class="item-icon" />
                    </div>
                </div>
                <div class="left">
                    <div
                        class="align-item"
                        :class="{ active: item.id == fontAlignVActiveID }"
                        v-for="item in fontAlignVList"
                        :key="item.id"
                        @click.stop="clickAlign('v', item.id)"
                        @mouseenter="startPreviewAlign('v', item.id)"
                        @mouseleave="endPreview"
                        :content="$t(`tipsList.${item.name}`)"
                        v-tippy="{ placement: 'bottom' }"
                    >
                        <iconSymbol :name="item.name" class="item-icon" />
                    </div>
                </div>
            </div>
        </div>
        <div class="fontset-box spacing-box" :class="{ disabled: !isSelect }">
            <p class="box-title">{{ $t("spacing") }}</p>
            <div>
                <div class="inputbox-line" @click="cancelRemind()">
                    <p class="inputbox-title">{{ $t("lineHeight") }}</p>
                    <InputNumber
                        class="iview_input"
                        v-model="lineHeight"
                        size="small"
                        :min="0.8"
                        :max="9007199254740992"
                        :step="0.1"
                        :disabled="isTextPath || !isSelect"
                        :precision="1"
                        :active-change="false"
                        @on-focus="editLocker('focus', 'lockInput')"
                        @on-blur="
                            editLocker('blur', 'lockInput', () => {
                                setFontMargin(0);
                                trackStyleSet('space');
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lockInput', () => {
                                setFontMargin(0);
                                trackStyleSet('space');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
                <div class="inputbox-line" @click="cancelRemind()">
                    <p class="inputbox-title">{{ $t("before") }}</p>
                    <InputNumber
                        class="iview_input"
                        v-model="before"
                        size="small"
                        :min="0"
                        :max="9007199254740992"
                        :step="1"
                        :disabled="isTextPath || !isSelect"
                        :formatter="(value) => `${Math.round(value * 10) / 10} pt`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        :active-change="false"
                        @on-focus="editLocker('focus', 'lockInput')"
                        @on-blur="
                            editLocker('blur', 'lockInput', () => {
                                setFontMargin(4);
                                trackStyleSet('space');
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lockInput', () => {
                                setFontMargin(4);
                                trackStyleSet('space');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
                <div class="inputbox-line" @click="cancelRemind()">
                    <p class="inputbox-title">{{ $t("after") }}</p>
                    <InputNumber
                        class="iview_input"
                        v-model="after"
                        size="small"
                        :min="0"
                        :max="9007199254740992"
                        :step="1"
                        :disabled="isTextPath || !isSelect"
                        :formatter="(value) => `${Math.round(value * 10) / 10} pt`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        :active-change="false"
                        @on-focus="editLocker('focus', 'lockInput')"
                        @on-blur="
                            editLocker('blur', 'lockInput', () => {
                                setFontMargin(5);
                                trackStyleSet('space');
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lockInput', () => {
                                setFontMargin(5);
                                trackStyleSet('space');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
            </div>
        </div>
        <div class="fontset-box indent-box" :class="{ disabled: !isSelect }">
            <p class="box-title">{{ $t("indent") }}</p>
            <div>
                <div class="inputbox-line" @click="cancelRemind()">
                    <p class="inputbox-title">{{ $t("firstIndent") }}</p>
                    <InputNumber
                        class="iview_input"
                        v-model="firstIndent"
                        size="small"
                        :min="0"
                        :max="maxIndent"
                        :step="1"
                        :disabled="isTextPath || !isSelect"
                        :formatter="(value) => `${Math.round(value * 10) / 10}${dynamicUnit}`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        :active-change="false"
                        @on-focus="editLocker('focus', 'lockInput')"
                        @on-blur="
                            editLocker('blur', 'lockInput', () => {
                                setFontMargin(1);
                                trackStyleSet('indent');
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lockInput', () => {
                                setFontMargin(1);
                                trackStyleSet('indent');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
                <div class="inputbox-line" @click="cancelRemind()">
                    <p class="inputbox-title">{{ $t("leftIndent") }}</p>
                    <InputNumber
                        class="iview_input"
                        v-model="leftIndent"
                        size="small"
                        :min="0"
                        :max="maxIndent - rightIndent"
                        :step="1"
                        :disabled="isTextPath || !isSelect"
                        :formatter="(value) => `${Math.round(value * 10) / 10}${dynamicUnit}`"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        :active-change="false"
                        @on-focus="editLocker('focus', 'lockInput')"
                        @on-blur="
                            editLocker('blur', 'lockInput', () => {
                                setFontMargin(2);
                                trackStyleSet('indent');
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lockInput', () => {
                                setFontMargin(2);
                                trackStyleSet('indent');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
                <div class="inputbox-line" @click="cancelRemind()">
                    <p class="inputbox-title">{{ $t("rightIndent") }}</p>
                    <InputNumber
                        class="iview_input"
                        v-model="rightIndent"
                        size="small"
                        :min="0"
                        :max="maxIndent - leftIndent"
                        :step="1"
                        :disabled="isTextPath || !isSelect"
                        :formatter="(value) => `${Math.round(value * 10) / 10}${dynamicUnit}`"
                        :active-change="false"
                        :parser="(value) => value.replace(/[\sa-zA-Z]*/g, '')"
                        @on-focus="editLocker('focus', 'lockInput')"
                        @on-blur="
                            editLocker('blur', 'lockInput', () => {
                                setFontMargin(3);
                                trackStyleSet('indent');
                            })
                        "
                        @on-change="
                            editLocker('edit', 'lockInput', () => {
                                setFontMargin(3);
                                trackStyleSet('indent');
                            })
                        "
                        @keyup.enter.native="iviewInputBlur($event)"
                    ></InputNumber>
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts">
    declare var EDChart: any;
    import { Component, Prop, Vue, Inject } from "vue-property-decorator";
    import fontTool from "@/app/mixin/fontTool";
    import FontSetPath from "./FontSetPath.vue";

    @Component({
        components: { FontSetPath },
    })
    export default class FontSet extends fontTool {
        @Inject()
        ["iviewInputBlur"];
        @Inject()
        ["showMessage"];
        @Prop(String) readonly from!: string;
        showState = {
            family: false,
            size: false,
        };

        lockInput: boolean = false;
        showTextPath: boolean = false;
        showAlign: boolean = false;
        showBullet: boolean = false;
        showLineSpace: boolean = false;
        fontAlignHList: Array<{ id: number; text: string; name: string }> = [
            {
                id: 0,
                text: "",
                name: "centerleft",
            },
            {
                id: 1,
                text: "",
                name: "center",
            },
            {
                id: 2,
                text: "",
                name: "centerright",
            },
        ];
        fontAlignVList: Array<{ id: number; text: string; name: string }> = [
            {
                id: 0,
                text: "",
                name: "topaside",
            },
            {
                id: 1,
                text: "",
                name: "centeraside",
            },
            {
                id: 2,
                text: "",
                name: "bottomaside",
            },
        ];

        get listStyleList() {
            return [
                {
                    id: 0,
                    text: "",
                    name: this.lang === "zh" ? "new-liststyle-1-zh" : "new-liststyle-1-cn",
                },
                {
                    id: 1,
                    text: "",
                    name: "new-liststyle-2",
                },
                {
                    id: 2,
                    text: "",
                    name: "new-liststyle-3",
                },
                {
                    id: 3,
                    text: "",
                    name: "new-liststyle-4",
                },
                {
                    id: 4,
                    text: "",
                    name: "new-liststyle-5",
                },
                {
                    id: 5,
                    text: "",
                    name: "new-liststyle-6",
                },
                {
                    id: 6,
                    text: "",
                    name: "new-liststyle-7",
                },
                {
                    id: 7,
                    text: "",
                    name: "new-liststyle-8",
                },
                {
                    id: 8,
                    text: "",
                    name: "new-liststyle-9",
                },
            ];
        }
        size: number[] = [6, 7, 8, 9, 10, 11, 12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72];
        family: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
            "仿宋",
            "楷书",
            "隶书",
            "微软雅黑",
            "黑体",
            "宋体",
            "华文楷体",
            "华文行楷",
            "华文新魏",
        ];
        enFamily: string[] = [
            "Arial",
            "Arial Black",
            "Book Antiqua",
            "Bookman Old style",
            "Calibri",
            "Calibri Light",
            "Cambria",
            "Candara",
            "Century",
            "Century Gothic",
            "Comic Sans MS",
            "Consolas",
            "Constantia",
            "Corbel",
            "Courier New",
            "Franklin Gothic Medium",
            "Garamond",
            "Georgia",
            "Lucida Sans Unicode",
            "Malgun Gothic",
            "Meiryo",
            "Microsoft JhengHei",
            "MS Gothic",
            "MS Mincho",
            "MS PGothic",
            "MS PMincho",
            "PMingLiU-ExtB",
            "Segoe UI",
            "Segoe UI Light",
            "Sylfaen",
            "Tahoma",
            "TH SarabunPSK",
            "Times",
            "Times New Roman",
            "Trebuchet MS",
            "Verdana",
        ];
        zhFamily: string[] = ["仿宋", "楷书", "隶书", "微软雅黑", "黑体", "宋体", "华文楷体", "华文行楷", "华文新魏"];

        showbackgroundColor: boolean = false;
        showListStyle: boolean = false;
        showFamilyList: boolean = false;
        showSizeList: boolean = false;
        selectFontEditor: number = -1;
        oldFontSize: number = 0;

        get isTextPath() {
            return this.$store.state.shape.fontFmt.isTextPath;
        }

        get actived() {
            return this.$store.state.shape.fontFmt.actived;
        }

        get strike() {
            if (!this.actived) return false;
            return this.$store.state.shape.fontFmt.strike;
        }

        get superscript() {
            if (!this.actived) return false;
            return this.$store.state.shape.fontFmt.superscript;
        }

        get subscript() {
            if (!this.actived) return false;
            return this.$store.state.shape.fontFmt.subscript;
        }

        get bold() {
            // if (!this.actived) return false;
            if (this.isEchart) return this.echartOption?.fontWeight == "bold";
            else if (this.isSelect) return this.$store.state.shape.fontFmt.bold;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultBold;
            else return this.$store.state.page.themeTextBold;
        }
        get italic() {
            // if (!this.actived) return false;
            if (this.isEchart) return this.echartOption?.fontStyle == "italic";
            else if (this.isSelect) return this.$store.state.shape.fontFmt.italic;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultItalic;
            else return this.$store.state.page.themeTextItalic;
        }
        get underline() {
            // if (!this.actived) return false;
            if (this.isSelect) return this.$store.state.shape.fontFmt.underline;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultUnderline;
            else return this.$store.state.page.themeTextUnderline;
        }

        get fmtType() {
            return this.$store.state.ui.fmtType;
        }

        get fontColor() {
            let color = this.$store.state.shape.fontFmt.color;
            if (this.isEchart) color = this.echartOption?.color;
            else if (this.isSelect) color = this.$store.state.shape.fontFmt.color;
            else if (this.customSet && !this.ignoreDefFont) color = this.$store.state.ui.customDefaultFontColor;
            else color = this.$store.state.page.themeTextColor;
            if (color == null) {
                color = "#000";
            }
            return color;
        }

        get lineHeight() {
            if (!this.actived) return 1;
            return this.$store.state.shape.fontFmt.lineSpace;
        }
        get firstIndent() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.firstIndent;
        }
        get leftIndent() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.leftIndent;
        }
        get rightIndent() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.rightIndent;
        }
        get before() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.before;
        }
        get after() {
            if (!this.actived) return 0;
            return this.$store.state.shape.fontFmt.after;
        }
        set lineHeight(v) {
            this.$store.commit("setFontFmtData", {
                type: "lineSpace",
                data: v,
            });
        }
        set firstIndent(v) {
            this.$store.commit("setFontFmtData", {
                type: "firstIndent",
                data: v,
            });
        }
        set leftIndent(v) {
            this.$store.commit("setFontFmtData", {
                type: "leftIndent",
                data: v,
            });
        }
        set rightIndent(v) {
            this.$store.commit("setFontFmtData", {
                type: "rightIndent",
                data: v,
            });
        }
        set before(v) {
            this.$store.commit("setFontFmtData", {
                type: "before",
                data: v,
            });
        }
        set after(v) {
            this.$store.commit("setFontFmtData", {
                type: "after",
                data: v,
            });
        }

        get dynamicUnit() {
            return this.$store.state.shape.fontFmt.dynamicUnit;
        }

        get maxIndent() {
            return this.$store.state.shape.fontFmt.maxIndent;
        }

        get fontAlignActiveID() {
            if (this.isSelect) return this.$store.state.shape.fontFmt.align;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultAlign;
            else return this.$store.state.page.themeTextAlign;
        }

        get fontAlignVActiveID() {
            return this.getRenderAlignID(this.fontAlignActiveID).vAlign;
        }

        get fontAlignHActiveID() {
            return this.getRenderAlignID(this.fontAlignActiveID).hAlign;
        }

        get listStyleActiveID() {
            return this.$store.state.shape.fontFmt.bulletStyle;
        }

        get fontBackGroundColor() {
            return this.$store.state.shape.fontFmt.backClr;
        }

        get activeFunc() {
            return this.$store.state.ui.activeFunc;
        }
        set activeFunc(v) {
            this.$store.commit("setStatus", {
                type: "activeFunc",
                data: v,
            });
        }

        get isSelect() {
            return !!this.$store.state.shape.isActived;
        }
        get isEDChart() {
            return window["_view"]._activeShape && window["_view"]._activeShape instanceof EDChart;
        }
        get isEchart() {
            return this.$store.state.shape.type == "EChartItem";
        }
        get echartOption() {
            if (!this.$store.state.newEchart.activeChartOption) return null;
            const option = JSON.parse(this.$store.state.newEchart.activeChartOption);
            return option.textStyle;
        }
        get chartIndex() {
            return this.$store.state.echart.index;
        }
        get customSet() {
            return this.$store.state.ui.defaultFontType == 1;
        }
        get ignoreDefFont() {
            return this.$store.state.page.ignoreDefFont;
        }
        set ignoreDefFont(v) {
            let payload = {
                type: "ignoreDefFont",
                data: v,
            };
            this.$store.commit("setPageStat", payload);
        }

        get activedFamily() {
            // if (!this.actived) return '';
            if (this.isEchart) return this.echartOption?.fontFamily;
            else if (this.isSelect) return this.$store.state.shape.fontFmt.family || "";
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultFamily;
            else return this.$store.state.page.themeTextFamily;
        }
        get activedSize() {
            // if (!this.actived) return '';
            if (this.isEchart) return this.echartOption?.fontSize;
            else if (this.isSelect) return this.$store.state.shape.fontFmt.size;
            else if (this.customSet && !this.ignoreDefFont) return this.$store.state.ui.customDefaultSize;
            else return this.$store.state.page.themeTextSize;
        }
        set activedSize(v) {
            if (this.isEchart) {
                this.applyFontSize(v);
            } else if (this.isSelect) {
                let payload = {
                    type: "size",
                    data: v,
                };
                this.$store.commit("setFontFmtData", payload);
            } else {
                let obj = {
                    type: "customDefaultSize",
                    data: v,
                };
                this.$store.commit("setStatus", obj);

                this.changePageFont({
                    type: "size",
                    data: typeof v == "string" ? parseInt(v) : v,
                });
            }
        }

        cancelRemind() {
            this.activeFunc = "";
        }

        editLocker(type, lock, fn?) {
            let map = new Map([
                [
                    "focus",
                    () => {
                        this[lock] = true;
                    },
                ],
                [
                    "blur",
                    () => {
                        this[lock] = false;
                        fn();
                    },
                ],
                [
                    "edit",
                    () => {
                        if (!this[lock]) {
                            fn();
                        }
                    },
                ],
            ]);
            map.get(type)();
        }

        trackStyleSet(type) {
            this.sensors.track("styleSet", {
                Catalogues: "rightMenu Bar",
                text_tab: type,
            });
        }
        // font
        setFontMargin(type) {
            switch (type) {
                case 0: {
                    // LINE
                    this.ft_setLineHeight(this.lineHeight);
                    // this.$track("fastTool", "font lineHeight", this.lineHeight);
                    break;
                }
                case 1: {
                    // FIRST IDENT
                    this.ft_setFirstIndent(this.firstIndent);
                    // this.$track("fastTool", "font firstIndent", this.firstIndent);
                    break;
                }
                case 2: {
                    // LEFT IDENT
                    this.ft_setLeftIndent(this.leftIndent);
                    // this.$track("fastTool", "font leftIndent", this.leftIndent);
                    break;
                }
                case 3: {
                    // RIGHT IDENT
                    this.ft_setRightIndent(this.rightIndent);
                    // this.$track("fastTool", "font rightIndent", this.rightIndent);
                    break;
                }
                case 4: {
                    // BEFORE
                    this.ft_setBefore(this.before);
                    // this.$track("fastTool", "font before", this.before);
                    break;
                }
                case 5: {
                    // AFTER
                    this.ft_setAfter(this.after);
                    // this.$track("fastTool", "font after", this.after);
                    break;
                }
            }
        }

        clickAlign(type, i) {
            // let alignText = [
            //     ["left", "top"],
            //     ["center", "top"],
            //     ["right", "top"],
            //     ["justify", "top"],
            //     ["left", "middle"],
            //     ["center", "middle"],
            //     ["right", "middle"],
            //     ["justify", "middle"],
            //     ["left", "bottom"],
            //     ["center", "bottom"],
            //     ["right", "bottom"],
            //     ["justify", "bottom"],
            // ];
            this.selectFontEditor = -1;
            let v = type === "v" ? i : this.fontAlignVActiveID;
            let h = type === "h" ? i : this.fontAlignHActiveID;
            let index = this.getRealAlignId(v, h);
            if (this.isSelect) {
                this.ft_setAlign(index);
            } else {
                // this.changePageFont({
                //     type: "align",
                //     data: index,
                // });
            }
            this.trackStyleSet("alignment");
            // this.$track("fastTool", "font align", alignText[index]);
        }
        startPreviewAlign(type, i) {
            let v = type === "v" ? i : this.fontAlignVActiveID;
            let h = type === "h" ? i : this.fontAlignHActiveID;
            let id = this.getRealAlignId(v, h);
            this.ft_previewAlign(id);
        }

        endPreview() {
            this.ft_endPreview();
        }

        checkFontSize() {
            this.showSizeList = false;
            document.removeEventListener("click", this.closeSizeList);
            if (!this.isEchart) {
                this.applyFontSize(this.activedSize);
            }
        }

        setOldSize(e) {
            this.oldFontSize = e.target.value;
        }
        applyFontSize(size) {
            if (this.oldFontSize == size)
                // 未更改值，直接返回
                return;
            let status = this.ft_checkSizeOK(size);
            if (!status.status && status.code !== 0) {
                // fontsize超出限制，弹出提示
                let ts = this as any;
                // if (status.code == 0) {
                //     ts.showMessage({
                //         type: 2,
                //         content: ts.$t("msgContent") + status.data + ts.$t("msgContent2"),
                //     });

                // } else {
                // }
                ts.showMessage({
                    type: 2,
                    content: ts.$t("msgContent3") + status.data,
                });
                this.oldFontSize = size;
                this.applyFontSize(1000);
                return;
            }
            this.trackStyleSet("text");

            if (this.isEDChart) {
                this.ft_setChartSize(this.chartIndex, size);
            } else if (this.isEchart) {
                this.ft_setEchartFont({
                    fontSize: size,
                });
            } else if (this.isSelect) {
                this.ft_setSize(size - 0);
            } else {
                // 设置页面属性并记录到用户偏好
                // this.changePageFont({
                //     type: "size",
                //     data: parseInt(size),
                // });
            }
        }

        clickFamilyName() {
            if (!this.isSelect) return;
            if (this.showFamilyList) {
                this.showFamilyList = false;
                document.removeEventListener("click", this.closeFamilyList);
            } else {
                this.showFamilyList = true;
                document.addEventListener("click", this.closeFamilyList);
            }
            // 打开列表时定位到当前选中字体
            this.$nextTick(() => {
                const dom = this.$refs.fontList as HTMLElement;
                let activeChild = dom.querySelector(".active") as HTMLElement;
                if (!activeChild) return;
                dom.scrollTop = activeChild.offsetTop - activeChild.offsetHeight * 2;
            });
        }
        clickSizeName() {
            if (!this.isSelect) return;
            if (this.showSizeList) {
                this.showSizeList = false;
                document.removeEventListener("click", this.closeSizeList);
            } else {
                this.oldFontSize = this.activedSize;
                this.showSizeList = true;
                document.addEventListener("click", this.closeSizeList);
            }
            // 打开列表时定位到当前选中字号
            this.$nextTick(() => {
                const dom = this.$refs.sizeList as HTMLElement;
                let activeChild = dom.querySelector(".active") as HTMLElement;
                if (!activeChild) return;
                dom.scrollTop = activeChild.offsetTop - activeChild.offsetHeight * 2;
            });
        }
        clickFamilyList(index) {
            this.showFamilyList = false;
            document.removeEventListener("click", this.closeFamilyList);

            if (this.isEDChart) {
                this.ft_setChartFamily(this.chartIndex, this.family[index]);
            } else if (this.isEchart) {
                this.ft_setEchartFont({
                    fontFamily: this.family[index],
                });
            } else if (this.isSelect) {
                this.ft_setFamily(this.family[index]);
            } else {
                // this.changePageFont({
                //     type: "family",
                //     data: this.family[index],
                // });
            }
            this.trackStyleSet("text");
        }
        startFamilyPreview(name) {
            this.ft_previewName(name);
        }
        clickSizeList(index) {
            this.showSizeList = false;
            document.removeEventListener("click", this.closeSizeList);

            this.applyFontSize(this.size[index]);
        }

        startSizePreview(data) {
            this.ft_previewSize(data);
        }
        closeFamilyList(e) {
            let objTarget = document.getElementById(`rightfamilyName`);
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                this.showFamilyList = false;
                document.removeEventListener("click", this.closeFamilyList);
            }
        }
        closeSizeList(e) {
            let objTarget = document.getElementById(`rightSizeName`);
            if (objTarget != e.target && !objTarget?.contains(e.target)) {
                this.showSizeList = false;
                document.removeEventListener("click", this.closeSizeList);
            }
        }

        changePageFont(data) {
            // this.$bus.$emit("changePageFont", data); 右侧边栏文字设置不设置全局偏好
        }

        get fontColorWindow() {
            return this.$store.state.ui.fontColorWindow;
        }

        showFontColor(e) {
            if (!this.isSelect) return;
            this.cancelRemind();
            // if(!this.isSelect) return;
            if (this.fontColorWindow) {
                return;
            }
            let node = e.target;
            let payload = {
                type: this.fmtType.font,
                index: 0,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                // this.$store.commit("setStatus", {
                //     type: "couldFixWindow",
                //     data: true,
                // });
                this.$store.dispatch("usePalette", { e, type: "fontColor", rightPanel: true });
            });
        }
        showFontBackgoundColor(e) {
            if (!this.isSelect) return;
            this.cancelRemind();
            if (this.isTextPath) return;
            this.showbackgroundColor = true;
            let node = e.target;
            let payload = {
                type: this.fmtType.font,
                index: 1,
            };
            this.$store.commit("setColor", payload);
            this.$nextTick(() => {
                this.$store.dispatch("usePalette", { e, type: "fontbgColor", rightPanel: true });
            });
        }

        clickBtn(type: string) {
            if (!this.isSelect) return;
            this.cancelRemind();
            if (this.isEDChart) {
                switch (type) {
                    case "bold": {
                        let bold = this.$store.state.shape.fontFmt.bold;
                        this.ft_setChartBold(this.chartIndex, bold);
                        this.$track("fastTool", "chart bold", bold);

                        break;
                    }
                    case "italy": {
                        let italic = this.$store.state.shape.fontFmt.italic;
                        this.ft_setChartItalic(this.chartIndex, italic);
                        this.$track("fastTool", "chart italic", italic);

                        break;
                    }
                    default: {
                        break;
                    }
                }
            } else if (this.isEchart) {
                switch (type) {
                    case "bold": {
                        this.ft_setEchartFont({
                            fontWeight: !this.bold ? "bold" : "normal",
                        });
                        break;
                    }
                    case "italy": {
                        this.ft_setEchartFont({
                            fontStyle: !this.italic ? "italic" : "normal",
                        });
                        break;
                    }
                    default: {
                        break;
                    }
                }
            } else {
                switch (type) {
                    case "bold": {
                        if (this.isSelect) {
                            this.ft_setBold(!this.bold);
                        } else {
                            // this.changePageFont({
                            //     type,
                            //     data: !this.bold,
                            // });
                        }
                        this.$track("fastTool", "font bold", !this.bold);

                        break;
                    }
                    case "italy": {
                        if (this.isSelect) {
                            this.ft_setItalic(!this.italic);
                        } else {
                            // this.changePageFont({
                            //     type,
                            //     data: !this.italic,
                            // });
                        }
                        this.$track("fastTool", "font italic", !this.italic);

                        break;
                    }
                    case "underline": {
                        if (this.isSelect) {
                            this.ft_setUnderline(!this.underline);
                        } else {
                            // this.changePageFont({
                            //     type,
                            //     data: !this.underline,
                            // });
                        }
                        this.$track("fastTool", "font underline", !this.underline);

                        break;
                    }
                    case "superscript": {
                        if (this.isSelect) {
                            this.ft_setSuperscript(!this.superscript);
                        }
                        this.$track("fastTool", "font superscript", !this.superscript);
                        break;
                    }
                    case "subscript": {
                        if (this.isSelect) {
                            this.ft_setSubscript(!this.subscript);
                        }
                        this.$track("fastTool", "font subscript", !this.subscript);
                        break;
                    }
                    case "strikethrough": {
                        this.ft_setLineThrough(!this.strike);
                        this.$track("fastTool", "font strikethrough", !this.strike);
                        break;
                    }
                }
            }
            this.trackStyleSet("text");
        }

        // liststyle modal
        showListStyleModal() {
            if (!this.isSelect) return;
            this.cancelRemind();
            if (this.isTextPath) return;
            this.showListStyle = !this.showListStyle;
        }
        closeListStyle(e) {
            this.showListStyle = false;
        }

        clickListStyle(index) {
            this.showListStyle = false;
            this.ft_setListStyle(index);
            this.$track("fastTool", "font bullet", index);
            this.trackStyleSet("text");
        }

        mounted() {
            if (this.lang == "zh") {
                this.family = this.zhFamily.concat(this.enFamily);
            } else {
                this.family = this.enFamily.concat(this.zhFamily);
            }
        }
        beforeDestroy() {}
    }
</script>
<i18n>
{
  "zh": {
    "textSet": "文本", 
    "align": "对齐",
    "spacing": "间距",
    "lineHeight": "行距",
    "firstIndent": "首行缩进",
    "leftIndent": "左侧缩进",
    "rightIndent": "右侧缩进",
    "before": "段前",
    "after": "段后",
    "indent": "缩进",
    "tipsList": {
        "bold": "加粗 Ctrl+B",
        "italy": "斜体 Ctrl+I",
        "underline": "下划线 Ctrl+U",
        "textColor": "文本颜色",
        "textAround": "文本在路径上",
        "textAlign": "对齐方式",
        "moreOption": "更多文本设置",
        "deleteLine": "删除线",
        "fontpath": "路径",
        "superscript": "上标",
        "subscript": "下标",
        "bgColor": "背景色",
        "listStyle": "列表样式",
        "centerleft": "左对齐",
        "center": "水平居中对齐",
        "centerright": "右对齐",
        "topaside": "顶部对齐",
        "centeraside": "垂直居中对齐",
        "bottomaside": "底部对齐"
    }
  },
  "en": {
    "textSet": "Text",
    "align": "Align",
    "spacing": "Space",
    "lineHeight": "Line Height",
    "firstIndent": "First Indent",
    "leftIndent": "Left Indent",
    "rightIndent": "Right Indent",
    "before": "Before Paragraph",
    "after": "After Paragraph",
    "indent": "Indent",
    "tipsList": {
        "bold": "Bold Ctrl+B",
        "italy": "Italic Ctrl+I",
        "underline": "Underline Ctrl+U",
        "textColor": "Font Color",
        "textAround": "Text on path",
        "textAlign": "Align",
        "moreOption": "More Options",
        "deleteLine": "Strikethrough ",
        "fontpath": "Text on path",
        "superscript": "Superscript",
        "subscript": "Subscript",
        "bgColor": "Text Highlight Color",
        "listStyle": "Bullets",
        "centerleft": "Left",
        "center": "Middle",
        "centerright": "Right",
        "topaside": "Top",
        "centeraside": "Center",
        "bottomaside": "Bottom"
    }
  },
  "fr": {
    "textSet": "Texte", 
    "align": "Aligner",
    "spacing": "Espace",
    "lineHeight": "Hauteur de ligne",
    "firstIndent": "Premier retrait",
    "leftIndent": "Retrait à gauche",
    "rightIndent": "Retrait à droite",
    "before": "Avant le paragraphe",
    "after": "Après le paragraphe",
    "indent": "Retrait",
    "tipsList": {
        "bold": "Audacieux",
        "italy": "Italique",
        "underline": "Souligner",
        "textColor": "Couleur du texte",
        "textAround": "Texte sur un chemin",
        "textAlign": "Alignement",
        "moreOption": "Plus de paramètres",
        "deleteLine": "Barré",
        "fontpath": "Texte sur un chemin",
        "superscript": "Exposant",
        "subscript": "Indice",
        "bgColor": "Couleur de fond",
        "listStyle": "Style de liste",
        "centerleft": "Gauche",
        "center": "Milieu",
        "centerright": "Droite",
        "topaside": "Haut",
        "centeraside": "Centre",
        "bottomaside": "Bas"
    }
  },
  "de": {
    "textSet": "Text", 
    "align": "Ausrichten",
    "spacing": "Leertaste",
    "lineHeight": "Zeilenhöhe",
    "firstIndent": "Erster Einzug",
    "leftIndent": "Linker Einzug",
    "rightIndent": "Rechter Einzug",
    "before": "Vor Absatz",
    "after": "Nach Absatz",
  
    "indent": "Einzug",
    "tipsList": {
        "bold": "Fett Ctrl+B",
        "italy": "Kursiv Ctrl+I",
        "underline": "Unterstreichen Ctrl+U",
        "textColor": "Textfarbe",
        "textAround": "Text auf Pfad",
        "textAlign": "Ausrichten",
        "moreOption": "Weitere Optionen",
        "deleteLine": "Durchstrichen",
        "fontpath": "Text auf Pfad",
        "superscript": "Hochgestellt",
        "subscript": "Tiefgestellt",
        "bgColor": "Hintergrundfarbe",
        "listStyle": "Listenformatvorlage",
       
        "centerleft": "Links",
        "center": "Mitte",
        "centerright": "Rechts",
        "topaside": "Oben",
        "centeraside": "Zentrum",
        "bottomaside": "Unten"
    }
  },
  "jp": {
    "textSet": "テキスト", 
    "align": "並び替え",
    "spacing": "間隔",
    "lineHeight": "行間",
    "firstIndent": "最初のインデント",
    "leftIndent": "左インデント",
    "rightIndent": "右インデント",
    "before": "段落の前",
    "after": "段落の後",
    "indent": "インデント",
    "tipsList": {
        "bold": "太字",
        "italy": "斜体",
        "underline": "下線",
        "textColor": "テキストの色",
        "textAround": "テキストの並べ方",
        "textAlign": "揃え方",
        "moreOption": "その他のオプション",
        "deleteLine": "取り消し線",
        "fontpath": "テキストの並べ方",
        "superscript": "上付き",
        "subscript": "下付き",
        "bgColor": "テキストの背景色",
        "listStyle": "箇条書き",
        "centerleft": "左",
        "center": "中央",
        "centerright": "右",
        "topaside": "上",
        "centeraside": "中央",
        "bottomaside": "下"
    }
  },
  "es": {
    "textSet": "Texto", 
    "align": "Alinear",
    "spacing": "Espacio",
    "lineHeight": "Altura de línea",
    "firstIndent": "Primera sangría",
    "leftIndent": "Sangría izquierda",
    "rightIndent": "Sangría derecha",
    "before": "Antes del párrafo",
    "after": "Después del párrafo",
    "indent": "Sangría",
    "tipsList": {
        "bold": "Negrita Ctrl+B",
        "italy": "Cursiva Ctrl+I",
        "underline": "Subraye Ctrl+U",
        "textColor": "Color de la fuente",
        "textAround": "Texto en Trazados",
        "textAlign": "Alinear",
        "moreOption": "Más opciones",
        "deleteLine": "Tachado",
        "fontpath": "Texto en Trazados",
        "superscript": "Superíndice",
        "subscript": "Subíndice",
        "bgColor": "Color de resalte del texto",
        "listStyle": "Balas",
        
        "centerleft": "Izquierda",
        "center": "Medio",
        "centerright": "Derecha",
        "topaside": "Arriba",
        "centeraside": "Centro",
        "bottomaside": "Inferior"
    }
  },
  "pt": {
    "textSet": "Texto", 
    "align": "Alinhar",
    "spacing": "Espaço",
    "lineHeight": "Altura da Linha",
    "firstIndent": "Primeiro recuo",
    "leftIndent": "Recuo à esquerda",
    "rightIndent": "Recuo à direita",
    "before": "Antes do parágrafo",
    "after": "Depois do parágrafo",
    "indent": "Recuo",
    "tipsList": {
        "bold": "Negrito Ctrl+B",
        "italy": "Itálico Ctrl+I",
        "underline": "Sublinhar Ctrl+U",
        "textColor": "Cor da Fonte",
        "textAround": "Texto num caminho",
        "textAlign": "Alinhar",
        "moreOption": "Mais Opções",
        "deleteLine": "Riscado",
        "fontpath": "Texto num caminho",
        "superscript": "Superior à Linha",
        "subscript": "Inferior à Linha",
        "bgColor": "Cor do Destaque de Texto",
        "listStyle": "Balas",
        "centerleft": "Esquerda",
        "center": "Meio",
        "centerright": "Direita",
        "topaside": "Acima",
        "centeraside": "Centro",
        "bottomaside": "Abaixo"
    }
  },
  "it": {
    "textSet": "Testo", 
    "align": "Allinea",
    "spacing": "Spazio",
    "lineHeight": "Altezza riga",
    "firstIndent": "Primo rientro",
    "leftIndent": "Rientro a sinistra",
    "rightIndent": "Rientro a destra",
    "before": "Prima del paragrafo",
    "after": "Dopo il paragrafo",
    "indent": "Rientro",
    "tipsList": {
        "bold": "Grassetto Ctrl+B",
        "italy": "Italico Ctrl+I",
        "underline": "Sottolineato Ctrl+U",
        "textColor": "Colore Carattere",
        "textAround": "Testo lungo tracciato",
        "textAlign": "Allinea",
        "moreOption": "Altre Opzioni",
        "deleteLine": "Barrato",
        "fontpath": "Testo lungo tracciato",
        "superscript": "Apice",
        "subscript": "Pedice",
        "bgColor": "Colore di Evidenziazione",
        "listStyle": "Punti Elenco",
        
        "centerleft": "A sinistra",
        "center": "In mezzo",
        "centerright": "A destra",
        "topaside": "In alto",
        "centeraside": "Al centro",
        "bottomaside": "In basso"
    }
  },
  "tw": {
    "textSet": "文本", 
    "align": "對齊",
    "spacing": "",
    "lineHeight": "行間距",
    "firstIndent": "首行縮進",
    "leftIndent": "左側縮進",
    "rightIndent": "右側縮進",
    "before": "段前間距",
    "after": "段後間距",
    "indent": "",
    "tipsList": {
        "bold": "加粗 Ctrl+B",
        "italy": "斜體 Ctrl+I",
        "underline": "下劃線 Ctrl+U",
        "textColor": "文本顏色",
        "textAround": "線上文本",
        "textAlign": "對齊方式",
        "moreOption": "更多文本設置",
        "deleteLine": "刪除線",
        "fontpath": "線上文本",
        "superscript": "上標",
        "subscript": "下標",
        "bgColor": "背景色",
        "listStyle": "列表樣式",
        
        "centerleft": "居中左對齊",
        "center": "居中",
        "centerright": "居中右對齊",
        "topaside": "頂部兩端對齊",
        "centeraside": "居中兩端對齊",
        "bottomaside": "底部兩端對齊"
    }
  }
}
</i18n>
